export const BREAKPOINTS = {
    mobile: 0,
    tablet: 1024,
    smalldesktop: 1280,
    desktop: 1600,
  };